import React from 'react';
import { Colors, Typography } from '@utex/ui-kit';
import { style } from './styles';

export const WarningSymbol: React.FC = () => (
  <Typography.Text color={Colors.text.error} size="L" css={style}>
    ⚠
  </Typography.Text>
);
